export const HEADLINE =
  'Du hast jetzt aussagekräftige Bewerbungsunterlagen erstellt, weißt aber nicht, wo Du Dich bewerben sollst?';

export const TEXT_CONTENT =
  'Bei XING findest Du die ideale Lösung! Im Jobs-Netzwerk kannst Du gezielt nach Jobs suchen, die genau Deinen Vorlieben und Qualifikationen entsprechen. Zusätzlich <strong>bieten wir Dir die Möglichkeit, von über 20.000 Recruitern gefunden zu werden</strong>. Viele spannende Jobs warten hier auf Dich. Nutze einfach einen der folgenden Jobsuche-Filter und starte Deine Karriere neu!';
